export enum PartnerLogType {
  INCREASE = 'увеличение',
  DECREASE = 'уменьшение',
}

export interface IPartnerLog {
  _id: string;
  track: string;
  date: string;
  partnerId: {
    name: string;
    surname: string;
  };
  type: PartnerLogType;
  amount: number;
  description: string;
  balanceBefore: number;
  balanceAfter: number;
  ownerId: {
    name: string;
  };
}
